<template>
  <div class="container">
    <v-tabs
      v-model="tab"
      bg-color="primary"
      class="control-view-tabs"
    >
      <v-tab value="prompt-tester">
        Prompt Tester
      </v-tab>
      <v-tab value="moderation-tester">
        Moderation Tester
      </v-tab>
      <v-tab value="polls">
        Polls
      </v-tab>
      <v-tab value="poll-creator">
        Poll Creator
      </v-tab>
      <v-tab value="fanart">
        Fanart
      </v-tab>
      <v-tab value="voicetest">
        Voicetest
      </v-tab>
      <v-tab value="anon-sprites">
        Anon Sprites
      </v-tab>
      <v-tab value="settings">
        Settings
      </v-tab>
      <v-btn
        href="/episodes"
        color="background"
        variant="text"
        class="ml-auto my-1 mr-8"
      >
        Go to episodes
      </v-btn>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item value="prompt-tester">
        <CustomPromptTester />
      </v-window-item>
      <v-window-item value="moderation-tester">
        <ModerationTester />
      </v-window-item>
      <v-window-item value="polls">
        <PollsListing />
      </v-window-item>
      <v-window-item value="poll-creator">
        <PollCreator />
      </v-window-item>
      <v-window-item value="fanart">
        <FanartSettings />
      </v-window-item>
      <v-window-item value="voicetest">
        <VoiceTest />
      </v-window-item>
      <v-window-item value="anon-sprites">
        <AnonSpritePlayground />
      </v-window-item>
      <v-window-item value="settings">
        <IcSettings />
      </v-window-item>
    </v-window>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CustomPromptTester from '../components/Control/CustomPromptTester.vue'
import PollsListing from '../components/Control/PollsListing.vue'
import PollCreator from '../components/Control/PollCreator.vue'
import FanartSettings from '../components/Control/FanartSettings.vue'
import VoiceTest from '../components/Control/VoiceTest.vue'
import AnonSpritePlayground from '../components/Control/AnonSpritePlayground.vue'
import IcSettings from '../components/Control/IcSettings.vue'
import ModerationTester from '../components/Control/ModerationTester.vue'

const validTabs = ['prompt-tester', 'moderation-tester', 'polls', 'poll-creator', 'fanart', 'voicetest', 'anon-sprites', 'settings'] as const
type Tab = typeof validTabs[number]

const route = useRoute()
const router = useRouter()

const getTabFromRoute = (): Tab => {
  const param = route.params.tab as string
  if (validTabs.includes(param as Tab)) {
    return param as Tab
  }
  return 'prompt-tester'
}

const tab = ref<Tab>(getTabFromRoute())

watch(() => route.params.tab, () => {
  tab.value = getTabFromRoute()
})

watch(tab, (newTab) => {
  if (route.params.tab !== newTab) {
    router.push({ name: 'control', params: { tab: newTab } })
  }
})
</script>
